import { Checkbox } from "../CheckBoxComponents/CheckBox";
import { produce } from "immer";

export default function QICheckboxes({
  currentQuestionViewIndex,
  childIndex,
  quizQuestions,
  setQuizQuestions,
}) {
  const toggleCheckBox = (optionIndex, checkBoxState) => {
    setQuizQuestions(
      produce((quizQuestionDraft) => {
        quizQuestionDraft[currentQuestionViewIndex].children[
          childIndex
        ].options[optionIndex].selected = checkBoxState;
        const currSelected =
          quizQuestionDraft[currentQuestionViewIndex].children[childIndex]
            .currSelected;
        const pos = currSelected.indexOf(optionIndex);
        if (pos === -1) {
          currSelected.push(optionIndex);
        } else {
          currSelected.splice(pos, 1);
        }
      })
    );
  };
  return (
    <>
      {quizQuestions[currentQuestionViewIndex].children[childIndex].options.map(
        (option, optionIndex) => {
          return (
            <Checkbox
              key={`${optionIndex}`}
              text={option.text}
              checkBoxState={option.selected}
              toggleCheckBox={(checkBoxState) => {
                toggleCheckBox(optionIndex, checkBoxState);
              }}
            />
          );
        }
      )}
    </>
  );
}
